import React, { Suspense, useEffect, useState } from "react";
import { TextField, MenuItem, Select, InputLabel, FormControl, Grid, Box } from "@mui/material";
import MDButton from "components/MDButton";
import RemoveIcon from '@mui/icons-material/Remove';
import MDModal from "components/MDModel";
const Campaign = React.lazy(() => import("./modal/campaign"));

const AdvancedFilter = ({ setFilter, clearFilter, componentName, selectedCampaign }) => {
  // State for filters and logical operators
  const [filters, setFilters] = useState([{ field: "", condition: "", value: "" }]);
  const [operators, setOperators] = useState([]);
  const [limit, setLimit] = useState();
  const [openModel, setOpenModel] = useState(false)
  const [openCampaignModal, setOpenCampaignModal] = useState(false);
  const [selectedFilterIndex, setSelectedFilterIndex] = useState(null);

  const fields = [
    { key: "company_id", name: "Company Id" },
    { key: "campaign_id", name: "Campaign Id" },
    { key: "company_name", name: "Company Name" },
    { key: "company_phone", name: "Company Phone" },
    { key: "company_email", name: "Company Email" },
    { key: "company_url", name: "Company Url" },
    { key: "primary_street_address1", name: "Company Address" },
    { key: "primary_state", name: "Company State" },
    { key: "primary_city", name: "Company City" },
    { key: "primary_postal_code", name: "Company Zip Code" },
    { key: "company_category", name: "Company Category" },
    { key: "LastInterest", name: "Last Event Interest" },
    { key: "CampaignEventCount", name: "Event Count" },
    { key: "event_type", name: "Event Type" },
    { key: "contact_made", name: "Contact Made" },
    { key: "unknown_contact", name: "Unknown Contact" },
    { key: "CampaignContactsCount", name: "Campaign Contact Count" },
    { key: "CampaignCollateralAttributeCount", name: "Campaign Callateral Attribute Count" },
    // { key: "interest_level", name: "Interest Level" },
  ];
  const conditions = [
    { key: "=", name: "Equals" },
    { key: "!=", name: "Not Equals" },
    { key: ">", name: "Greater Than" },
    { key: "<", name: "Less Than" },
    { key: "LIKE", name: "Include" },
  ];
  const logicalOperators = ["AND", "OR"];

  useEffect(() => {
    if (selectedCampaign) {
      setFilters([
        {
          field: "campaign_id",
          condition: "=",
          value: selectedCampaign,
        },
      ]);
    }
  }, [selectedCampaign]);

  // Add a new filter
  const addFilter = () => {
    setFilters([...filters, { field: "", condition: "", value: "" }]);
    if (filters.length > 0) setOperators([...operators, "AND"]); // Default logical operator
  };

  // Remove a filter
  const removeFilter = (index) => {
    const updatedFilters = filters.filter((_, idx) => idx !== index);
    const updatedOperators = operators.filter((_, idx) => idx !== index - 1);
    setFilters(updatedFilters);
    setOperators(updatedOperators);
  };

  // Update a filter
  const updateFilter = (index, key, value) => {
    const updatedFilters = [...filters];
    updatedFilters[index][key] = value;
    setFilters(updatedFilters);

    if (key === "field" && value === "campaign_id") {
      setSelectedFilterIndex(index);
      setOpenCampaignModal(true);
    }
  };

  // Update a logical operator
  const updateOperator = (index, value) => {
    const updatedOperators = [...operators];
    updatedOperators[index] = value;
    setOperators(updatedOperators);
  };

  // Handle apply filters
  const handleApplyFilters = () => {
    // Create deep copy of filters array
    let updatedFilters = filters.map(filter => ({...filter}));

    // Update values with LIKE condition
    updatedFilters = updatedFilters.map(fil => {
      if (fil.condition === 'LIKE') {
        return {...fil, value: `"%${fil.value}%"`};
      }
      if(fil.value === "0" && componentName === 'jobqueue'){
        return {...fil, value: 0};
      }
      if (fil.value === "0" && fil.condition === '=') {
        return {...fil, value: null};
      }
      return fil;
    });


    const filterObject = {
      filters: updatedFilters,
      operators,
      ...(limit !== undefined && { page: 1, pageSize: limit })
    };
  
    setFilter(filterObject);
    setOpenModel(false)
  };

  // Handle clear filters
  const handleClearFilters = () => {
    setFilters([{ field: "", condition: "", value: "" }]);
    setOperators([]);
    setLimit();
    clearFilter();
    setOpenModel(false)
  };

  const handleCampaignSelect = (campaign) => {
    if (selectedFilterIndex !== null) {
      const updatedFilters = [...filters];
      updatedFilters[selectedFilterIndex].value = campaign; 
      updatedFilters[selectedFilterIndex].condition = "="; 
      setFilters(updatedFilters);
      setSelectedFilterIndex(null);
    }
    setOpenCampaignModal(false);
  };

  return (
    <Box sx={{ pt: 0.5 }}>
      {/* <Typography variant="h6">Advanced Filter</Typography> */}
      <MDButton variant="contained" onClick={() => setOpenModel(true)}>
        Filter
      </MDButton>
      <MDModal open={openModel} onClose={() => setOpenModel(false)}
        footer={
          <>
            <MDButton onClick={handleApplyFilters} variant="contained">
              Apply
            </MDButton>
            <MDButton variant="outlined" onClick={handleClearFilters}>
              Clear
            </MDButton>
          </>
        }
      >
        <Grid container spacing={3}>
          {filters.map((filter, index) => (
            <React.Fragment key={index}>
              {/* Logical Operator (except before the first filter) */}
              {index > 0 && (
                <Grid item xs={12} sm={2}>
                  <FormControl fullWidth>
                    <InputLabel>Operator</InputLabel>
                    <Select
                      value={operators[index - 1] || "AND"}
                      onChange={(e) => updateOperator(index - 1, e.target.value)}
                      fullWidth
                      sx={{ height: '45px' }}
                      label="Operator"
                    >
                      {logicalOperators.map((op, idx) => (
                        <MenuItem key={idx} value={op}>
                          {op}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}

              {/* Field */}
              <Grid item xs={12} sm={3}>
                <FormControl fullWidth>
                  <InputLabel>Field</InputLabel>
                  <Select
                    label="Field"
                    value={filter.field}
                    onChange={(e) => updateFilter(index, "field", e.target.value)}
                    fullWidth
                    sx={{ height: '45px' }}
                  >
                    {fields.map((f, idx) => (
                      <MenuItem
                      key={idx}
                      value={f.key}
                      onClick={() => {
                        if (filter.field === f.key) {
                          updateFilter(index, "field", f.key);
                        }
                      }}
                    >
                      {f.name}
                    </MenuItem>
            
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* Condition */}
              <Grid item xs={12} sm={componentName === "dashboard" ? 3 : 2}>
                <FormControl fullWidth>
                  <InputLabel>Condition</InputLabel>
                  <Select
                    label="Condition"
                    value={filter.condition}
                    onChange={(e) => updateFilter(index, "condition", e.target.value)}
                    fullWidth
                    sx={{ height: '45px' }}
                  >
                    {conditions.map((c, idx) => (
                      <MenuItem key={idx} value={c.key}>
                        {c.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* Value */}
              <Grid item xs={12} sm={2}>
                <TextField
                  label="Value"
                  value={filter.value}
                  onChange={(e) => updateFilter(index, "value", e.target.value)}
                  fullWidth
                />
              </Grid>

              {/* Limit */}
              {(index === 0 && componentName === "jobqueue") && <Grid item xs={12} sm={2}>
              <TextField
                label="Limit"
                type="number"
                value={limit || ""}
                onChange={(e) => setLimit(e.target.value ? parseInt(e.target.value, 10) : undefined)}
                fullWidth
              />
              </Grid>}

              {/* Add Filter Button */}
              {
                index == 0 && (
                  <>
                    <Grid item xs={12} sm={3}>
                      <MDButton variant="contained" onClick={addFilter}>
                        Add
                      </MDButton>
                    </Grid>
                    {/* <Grid item xs={12} sm={2}>
                      <Box sx={{ display: "flex", gap: 2 }}>
                        <MDButton variant="contained" onClick={handleApplyFilters}>
                          Apply
                        </MDButton>
                        <MDButton variant="outlined" onClick={handleClearFilters}>
                          Clear
                        </MDButton>
                      </Box>
                    </Grid> */}
                  </>
                )
              }

              {/* Remove Filter Button */}
              {index > 0 && (
                <Grid item xs={12} sm={2}>
                  <MDButton variant="outlined" color="error" onClick={() => removeFilter(index)}>
                    <RemoveIcon />
                  </MDButton>
                </Grid>
              )}
            </React.Fragment>
          ))}
        </Grid>
      </MDModal>

      {openCampaignModal && (
        <Suspense fallback={<div>Loading...</div>}>
          <Campaign
            open={openCampaignModal}
            onClose={() => setOpenCampaignModal(false)}
            onSelect={handleCampaignSelect}
          />
        </Suspense>
      )}

    </Box>
  );
};

export default AdvancedFilter;


// import React, { useState } from "react";
// import { TextField, MenuItem, Select, InputLabel, FormControl, Grid, Box, Typography } from "@mui/material";
// import MDButton from "components/MDButton";
// import { useMediaQuery } from "react-responsive";

// const AdvancedFilter = ({ setFilter, clearFilter }) => {
//   // State for filter options
//   const [limit] = useState(0);
//   const [field, setField] = useState("");
//   const [condition, setCondition] = useState("");
//   const [value, setValue] = useState("");
//   const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })

//   // Available fields and conditions
//   const fields = [
//     {key: 'company_id', name: 'Company Id'},
//     {key: 'campaign_id', name: 'Campaign Id'},
//     {key: 'company_name', name: 'Company Name'},
//     {key: 'company_phone', name: 'Company Phone'},
//     {key: 'company_email', name: 'Company Email'},
//     {key: 'company_url', name: 'Company Url'},
//     {key: 'primary_street_address1', name: 'Company Address'},
//     {key: 'primary_state', name: 'Company State'},
//     {key: 'primary_city', name: 'Company City'},
//     {key: 'primary_postal_code', name: 'Company Zip Code'},
//     {key: 'company_category', name: 'Company Category'},
//   ];
// //   const conditions = ["Equals", "Not Equals"];
//   const conditions = [
//     {key: '=', name: 'Equals'},
//     {key: '!=', name: 'Not Equals'},
//     {key: '>', name: 'Greater Than'},
//     {key: '<', name: 'Less Than'},
//     {key: 'include', name: 'Include'},
//   ];

//   // Handle filter set
//   const handleSet = () => {
//     setFilter({ limit, field, condition, value })
//   };

//   // Handle clear button
//   const handleClear = () => {
//     setField("");
//     setCondition("");
//     setValue("");
//     clearFilter()
//   };

//   return (
//     <Box sx={{ pt: 1, pb: 1, width: '100%' }}>
//       <Typography variant="h6">Advanced Filter</Typography>
//       <Grid container spacing={3}>
//         {/* Field List */}
//         <Grid item xs={!isTabletOrMobile ? 3 : 4}>
//           <FormControl fullWidth>
//             <InputLabel>Field</InputLabel>
//             <Select
//               value={field}
//               onChange={(e) => setField(e.target.value)}
//               label="Field"
//               fullWidth
//               sx={{ height: '45px' }}
//             >
//               {fields.map((f, idx) => (
//                 <MenuItem key={idx} value={f.key}>
//                   {f.name}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         {/* Condition */}
//         <Grid item xs={!isTabletOrMobile ? 3 : 4}>
//           <FormControl fullWidth>
//             <InputLabel>Condition</InputLabel>
//             <Select
//               value={condition}
//               onChange={(e) => setCondition(e.target.value)}
//               label="Condition"
//               fullWidth
//               sx={{ height: '45px' }}
//             >
//               {conditions.map((c, idx) => (
//                 <MenuItem key={idx} value={c.key}>
//                   {c.name}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         {/* Value Input */}
//         <Grid item xs={!isTabletOrMobile ? 3 : 4}>
//           <TextField
//             label="Value"
//             value={value}
//             onChange={(e) => setValue(e.target.value)}
//             fullWidth
//           />
//         </Grid>

//         {/* Set Field */}
//         <Grid item xs={!isTabletOrMobile ? 3 : 4}>
//           <Box sx={{ display: "flex", gap: 2 }}>
//             <MDButton variant={'contained'} onClick={handleSet}>
//               Filter
//             </MDButton>
//             <MDButton variant={'outlined'} onClick={handleClear}>
//               Clear
//             </MDButton>
//           </Box>
//         </Grid>
//       </Grid>
//     </Box>
//   );
// };

// export default AdvancedFilter;
